import { Grid, Typography } from "@mui/material";
import React from "react";

export const CustomTable = ({
  tableHeader,
  rows,
  isTotalRow,
  totalValue,
  noDataAvailableText,
}) => {
  return (
    <Grid display="flex" flexDirection={"column"}>
      <Grid
        display={"flex"}
        justifyContent={"space-between"}
        style={{
          borderTop: "1px solid #DADADA",
          borderBottom: "1px solid #DADADA",
        }}
      >
        {tableHeader.map((item) => (
          <Grid flex={1} pt={1} pb={1}>
            <Typography textAlign={"center"} color={"#5E6470"} fontSize={12}>
              {item}
            </Typography>
          </Grid>
        ))}
      </Grid>
      {rows.map((row) => (
        <Grid display={"flex"} justifyContent={"space-between"} pt={1} pb={1}>
          {row.map((item) => (
            <Grid flex={1}>
              <Typography textAlign={"center"} color={"#1A1C21"} fontSize={12}>
                {item}
              </Typography>
            </Grid>
          ))}
        </Grid>
      ))}
      {rows.length === 0 && (
        <Grid
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          p={2}
        >
          <Typography textAlign={"center"} color={"#1A1C21"} fontSize={12}>
            {noDataAvailableText}
          </Typography>
        </Grid>
      )}
      {isTotalRow && (
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          style={{
            borderTop: "1px solid #DADADA",
          }}
        >
          {totalValue.map((item) => (
            <Grid flex={1} pt={1} pb={1}>
              <Typography
                textAlign={"center"}
                color={"#1A1C21"}
                fontSize={12}
                fontWeight={"bold"}
              >
                {item}
              </Typography>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};
